import { PropertyDistributionItem } from 'src/v2/views/owner-reveal/sidebar/result-overlay/properties-distribution-list'
import { FlexColumn, FlexRow } from 'src/components/flex-containers'
import { Colors, Shapes } from 'src/components/theme'
import { Typography } from '@mui/material'
import styled from '@emotion/styled'
import { formatString } from 'src/utils/format-string'
import { PARCEL_TYPE_ICON_MAP } from 'src/v2/components/parcel-type-chip'

const Header = styled(Typography)`
  padding: ${Shapes.spacing[2]}px;
  border-bottom: 1px dashed ${Colors.neutral200};
`
const PropertyRowContainer = styled(FlexRow)`
  padding: ${Shapes.spacing[2]}px;
  align-items: center;
`

type PropertyRowProps = {
  name: string
  value: number
  index: number
  total: number
}
const PropertyRow = ({ name, value, index, total }: PropertyRowProps) => {
  const Icon = PARCEL_TYPE_ICON_MAP[name as keyof typeof PARCEL_TYPE_ICON_MAP]
  return (
    <PropertyRowContainer
      style={{
        backgroundColor: total > 2 ? (index % 2 === 0 ? 'transparent' : Colors.neutral50) : 'transparent',
      }}>
      <FlexRow flex="1" align="center" gap={Shapes.spacing[2]}>
        {Icon && <Icon size={14} color={Colors.neutral300} />}
        <Typography variant="textmdm" color={Colors.neutral500}>
          {formatString(name, 'name')}
        </Typography>
      </FlexRow>
      <FlexRow flex="1" justify="center">
        <Typography variant="textmdm" color={Colors.neutral500}>
          {value}
        </Typography>
      </FlexRow>
    </PropertyRowContainer>
  )
}

export const PropertiesDistributionTable = (props: { list: PropertyDistributionItem[] }) => {
  return (
    <FlexColumn>
      <Header color={Colors.neutral700} variant="textmd">
        Parcel Types
      </Header>
      {props.list.map((item, index) => (
        <PropertyRow total={props.list.length} key={item.type} name={item.type} value={item.value} index={index} />
      ))}
    </FlexColumn>
  )
}
